export const workspaceFileRoute = '/api/hermes/files';

/** The caller supplies the configured site address and authenticated account. */
export function workspaceFileUrl(accountId: string, relativePath: string, publicOrigin: string, basePath: string): string {
  return `${publicOrigin}${basePath}${workspaceFileRoute}/${encodeURIComponent(accountId)}/${relativePath.split('/').map(encodeURIComponent).join('/')}`;
}
